export const notFoundRoute = {
  path: '*',
  lazy: async () => {
    const { NotFoundPage } =
      await import('../../pages/not-found/NotFound.page');

    return { Component: NotFoundPage };
  },
};
